/**
 * Utility functions for the application
 */

// Format Ethereum address for display
export const formatAddress = (address: string | null | undefined): string => {
  if (!address) return '';
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
};

// Extract error message from ethers error
export const extractErrorMessage = (error: any): string => {
  if (typeof error === 'string') return error;
  
  if (error.reason) return error.reason;
  if (error.message) return error.message;
  if (error.data?.message) return error.data.message;
  
  return 'Unknown error occurred';
};

// Parse string containing multiple addresses to array
export const parseAddressList = (addressesString: string): string[] => {
  if (!addressesString.trim()) return [];
  
  // Split by commas, semicolons, spaces, or newlines
  return addressesString
    .split(/[,;\s\n]+/)
    .map(addr => addr.trim())
    .filter(addr => addr.length > 0);
};

// Validate Ethereum address
export const isValidAddress = (address: string): boolean => {
  try {
    return /^0x[a-fA-F0-9]{40}$/.test(address);
  } catch (error) {
    return false;
  }
};

// Convert token ID to user-friendly shortened display format
export const formatTokenId = (tokenId: string): string => {
  if (!tokenId) return '';
  if (tokenId.length <= 10) return tokenId;
  
  return `${tokenId.substring(0, 6)}...${tokenId.substring(tokenId.length - 4)}`;
};

// Format number with commas
export const formatNumber = (num: number | string): string => {
  return new Intl.NumberFormat().format(Number(num));
};

// Convert string to buffer for IPFS operations
export const strToBuffer = (str: string): Buffer => {
  return Buffer.from(str);
};

// Set a JSON metadata to IPFS using NFT.Storage
export interface TokenMetadata {
  name: string;
  description: string;
  image?: string;
  external_url?: string;
  attributes?: Array<{
    trait_type: string;
    value: string | number;
  }>;
}